export const CHANNEL_TYPE                      = 'type';
export const CHANNEL_AUTH                      = 'auth';
export const CHANNEL_CHAT_SUBSCRIBE            = 'chat_subscribe';
export const CHANNEL_CHAT_UNSUBSCRIBE          = 'chat_unsubscribe';
export const CHANNEL_CHAT                      = 'chat';
export const CHANNEL_STREAM_SUBSCRIBE          = 'stream_subscribe';
export const CHANNEL_STREAM_UNSUBSCRIBE        = 'stream_unsubscribe';
export const CHANNEL_DISCOVERY_SUBSCRIBE       = 'discovery_subscribe';
export const CHANNEL_DISCOVERY_UNSUBSCRIBE     = 'discovery_unsubscribe';
export const CHANNEL_QUOTES_SUBSCRIBE          = 'quotes_subscribe';
export const CHANNEL_QUOTES_UNSUBSCRIBE        = 'quotes_unsubscribe';
export const CHANNEL_FLOW_SUBSCRIBE            = 'flow_subscribe';
export const CHANNEL_FLOW_UNSUBSCRIBE          = 'flow_unsubscribe';